module.exports = __webpack_public_path__ + "static/img/cfi.e672ee81.png";